import { useEffect, useState } from 'react';

export default function useIsMobile(breakpoint = 768) {
  const getInitial = () =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(`(max-width: ${breakpoint}px)`).matches
      : false;

  const [isMobile, setIsMobile] = useState(getInitial);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const media = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const listener = e => setIsMobile(e.matches);

    // Add/remove listeners with best compatibility
    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else {
      media.addListener(listener);
    }

    // keep state in sync in case of server -> client hydration
    setIsMobile(media.matches);

    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else {
        media.removeListener(listener);
      }
    };
  }, [breakpoint]);

  return isMobile;
}
